module.exports = __webpack_public_path__ + "img/4.a0bfe028.jpg";